import '@/polyfills';
import 'lodash';
import { render } from 'react-dom';
import { datadogRum } from '@datadog/browser-rum';
import { ChrLdProvider } from '@chr/common-launchdarkly';
import { OnlineTranslationProvider } from '@chr/online-shared-ui-localizations';
import { getConfiguration } from '@chr/common-web-ui-configuration';
import React from 'react';
import { OnlineProvider, Footer, AuthContext, UserProfileContext } from '@chr/navisphereonline-shared-components';
import { AppWrapper } from '@/app/AppWrapper';

export const index = (async () => {
  try {
    const config = await getConfiguration<AppConfig>();
    try {
      const { environment } = config;
      if (environment && environment !== 'local') {
        datadogRum.init({
          applicationId: 'bc160d93-5b4f-44bd-9453-3e18dd993681',
          clientToken: 'pub1a40b2d850bedeeddbd83c9106359cfe',
          site: 'us3.datadoghq.com',
          service: 'NavisphereOnline.PO.UI',
          env: environment,
          version: '1.0.0',
          sampleRate: 50,
          premiumSampleRate: 10,
          trackInteractions: true,
          defaultPrivacyLevel: 'mask-user-input',
          useSecureSessionCookie: true,
          allowedTracingOrigins: [/https:\/\/.*\.chrobinson\.com/],
          beforeSend: (event) => {
            event.view.url = event.view.url.toLowerCase().replace('#/', '');
          },
        });
      }
    } catch (error) {
      // Do not block loading for a datadog error
      // This is an error that can be thrown when ES modules aren't natively supported.
      // There is a pollyfill in place so we just swallow this error
      // temporarily until we find a better error handling solution
      if (error instanceof Error && error.message.includes('Error resolving module')) {
        return;
      }
      console.log(error);
      render(
        <h1>Error loading application</h1>,
        document.getElementById('root'),
      );
    }

    datadogRum.startSessionReplayRecording();

    render(
      <div>
        {/* <MedalliaFeedback /> */}
        <OnlineTranslationProvider>
          <OnlineProvider appConfig={config} defaultTheme="Navisphere Online">
            <UserProfileContext.Consumer>
              {(userProfile) => (
                <ChrLdProvider
                  envKey={config.launchDarklyClientId}
                  user={{ key: userProfile.email.toLowerCase() }}
                >
                  <AuthContext.Consumer>
                    {(authClient) => (
                      <AppWrapper
                        appConfig={config}
                        authClient={authClient}
                        userProfile={userProfile}
                      />
                    )}
                  </AuthContext.Consumer>
                  <Footer />
                </ChrLdProvider>
              )}
            </UserProfileContext.Consumer>
          </OnlineProvider>
        </OnlineTranslationProvider>
      </div>,
      document.getElementById('root'),
    );
  } catch (error) {
    console.log(error);
    render(<h1>Error loading application</h1>, document.getElementById('root'));
  }
})();
